class ListViewToggle {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.items = self.elem.querySelector('[data-list-view-items]');
        self.viewButtons = self.elem.querySelectorAll('[data-list-view-toggle]');
    }

    init() {
        let self = this;

        // Grid/list view toggle buttons
        [...self.viewButtons].map(item => {
            item.addEventListener('click', evt => {
                let view = item.getAttribute('data-list-view-toggle');

                self.selectView(view);
            });
        });

        // Switch to the previously selected view (if one was selected)
        let selectedCollectionsView = localStorage.getItem('list-view');

        if(selectedCollectionsView) {
            self.selectView(selectedCollectionsView);
        }
    }

    selectView(view) {
        let self = this;

        // Get the button for this view
        let button = self.elem.querySelector(`[data-list-view-toggle="${view}"]`);

        // Remove .is-active class from all buttons
        [...self.viewButtons].map(item => {
            item.classList.remove('is-active');
        });

        // Add .is-active class to this button
        button.classList.add('is-active');

        // Set the items-view key in Local Storage
        localStorage.setItem('list-view', view);

        // Apply the appropriate value to the data-items-view attribute on the list of items
        if(self.items) {
            self.items.setAttribute('data-list-view', view);
        }
    }
}

export default ListViewToggle;
